import {PanelType} from '../../components/WorkspaceDrawer/AddPanels/types';
import {makeTrackEvent} from './makeTrackEvent';

export type AddPanelsAction =
  | 'Drawer opened'
  | 'Disabled item docs clicked'
  | 'Group collapsed'
  | 'Group expanded'
  | 'Panel type selected'
  | 'Show less clicked'
  | 'Show more clicked';
export type AddPanelsScope = 'global' | 'section';
export type AddPanelsEvent = {
  action: AddPanelsAction;
  scope: AddPanelsScope;
  group?: string;
  panelType?: PanelType;
};

export const trackAddPanels = makeTrackEvent<
  AddPanelsEvent,
  {
    action: {
      description: 'the action that took place';
    };
    scope: {
      description: 'whether user is adding globally or to a specific section';
      exampleValues: ['global', 'section'];
    };
    group: {
      description: 'the name of the relevant panel type group';
      exampleValues: ['Charts', 'Media', 'Tables'];
    };
    panelType: {
      description: 'the selected panel type';
      exampleValues: ['image', 'line'];
    };
    _description: 'Tracks events related to add panels';
    _location: 'workspaces';
    _motivation: 'Track UI usage';
  }
>('Add panels');
